import { DefaultRoleTypesEnum } from 'modules/Workspaces/hooks/useCreateWorkspaceRole/utils';
import { PermissionConfigEntry, PermissionId } from 'utils/powerLevelsConfig';

export type { PermissionConfigEntry, PermissionId };

export enum CreateWorkspaceStepsEnum {
  CREATE = 'create',
  INVITE = 'invite',
  CREATE_ROLES = 'create-roles',
  SUCCESS = 'success',
}

export enum CreateWorkspaceMode {
  FULL = 'full',
  INVITE_ONLY = 'invite-only',
}

export type CreateWorkspaceInitOptions = {
  parentWorkspaceId: string | null;
  initialStep?: CreateWorkspaceStepsEnum;
  initialWorkspaceId?: string | null;
  mode?: CreateWorkspaceMode;
};

export enum WorkspaceType {
  WORKSPACE = 'workspace',
  SUB_WORKSPACE = 'sub-workspace',
}

export type WorkspacePowerLevels = {
  workspace: number;
  chat: number;
  meeting: number;
};

export type RoleAssignment = {
  matrixId: string | null;
  pendingEmail?: string | null;
  roleId: string;
  assignedBy: string;
};

export type WorkspaceRoleV1 = {
  id: string;
  name: string;
  defaultRoleType?: DefaultRoleTypesEnum;
  powerLevel: number;
};

export type WorkspaceRoleV2 = {
  id: string;
  name: string;
  defaultRoleType?: DefaultRoleTypesEnum;
  inherited?: true;
  powerLevels: WorkspacePowerLevels;
};

export type WorkspaceRole = WorkspaceRoleV2;

export type Permission = {
  id: PermissionId;
  enabled: boolean;
  label: string;
};

export const PERMISSION_CATEGORY_IDS = ['workspace', 'chat', 'meeting'] as const;
export type PermissionCategoryId = (typeof PERMISSION_CATEGORY_IDS)[number];

export type PermissionCategory = {
  id: PermissionCategoryId;
  labelKey: string;
  permissions: PermissionConfigEntry[];
};
